var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middlePicture"},[_c('img',{attrs:{"src":_vm.imgUrl,"autofocus":""}}),_c('h3',[_vm._v("发生错误了捏")])])
}
var staticRenderFns = []

export { render, staticRenderFns }